// SECTION 1
gsap.set(".co-clinic-1", { opacity: 0, transition: 0 });
gsap.set(".co-clinic-1-left>*", { opacity: 0, transition: 0 });
let coC1 = gsap.timeline();
coC1.to(".co-clinic-1", {
  opacity: 1,
  duration: 1,
});
coC1.to(".co-clinic-1-left>*", {
  opacity: 1,
  duration: 1,
  stagger: 0.15
}, "-=1");

// SWIPER
const coSwiper1 = new Swiper('.co-clinic-1 .swiper', {
  effect: "fade",
  slidesPerView: "auto",
  speed: 400,
  preventInteractionOnTransition: true,
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  pagination: {
    el: '.co-clinic-1 .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});
document.addEventListener("DOMContentLoaded", function (event) {
  window.requestAnimationFrame(function () {
    // SECTION 2
    gsap.set(".co-clinic-2", { opacity: 0, transition: 0 });
    gsap.set(".co-clinic-2-left>*", { opacity: 0, transition: 0 });
    let coC2 = gsap.timeline();
    coC2.to(".co-clinic-2", {
      opacity: 1,
      duration: 1,
    });
    coC2.to(".co-clinic-2-left>*", {
      opacity: 1,
      duration: 1,
      stagger: 0.15
    }, "-=0.9");
    // ScrollTrigger.create({
    //   trigger: ".co-clinic-2",
    //   start: "0% bottom",
    //   end: "bottom top",
    //   // toggleActions: "play reverse none none",
    //   animation: coC2
    // });
    gsap.to(".co-clinic-2-right-frame img", {
      scrollTrigger: {
        // markers: true,
        trigger: ".co-clinic-2",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: -20
    });
    // SECTION 3
    gsap.set(".co-clinic-3-right-frame", { opacity: 0, transition: 0 });
    let coC3 = gsap.timeline({ paused: true });
    coC3.to(".co-clinic-3-right-frame", {
      opacity: 1,
      duration: 1
    });
    ScrollTrigger.create({
      // markers: true,
      trigger: ".co-clinic-3-right-frame",
      start: "0% bottom",
      end: "bottom top",
      toggleActions: "play none none reverse",
      animation: coC3
    });
    gsap.to(".co-clinic-3-left-frame img", {
      scrollTrigger: {
        trigger: ".co-clinic-3-left-frame",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      top: "-5%"
    });
    // SECTION 4
    gsap.to(".co-clinic-4-drops img", {
      scrollTrigger: {
        trigger: ".co-clinic-4",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: 10,
      xPercent: 5
    });
    gsap.to(".co-clinic-4-item", {
      scrollTrigger: {
        trigger: ".co-clinic-4-grid",
        start: "15% bottom",
        end: "bottom top",
      },
      opacity: 1,
      duration: 1,
      stagger: 0.15
    });
    gsap.to(".co-clinic-4-drops-large img", {
      scrollTrigger: {
        trigger: ".co-clinic-4-drops-large",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: -20,
      xPercent: -15,
      rotateZ: -10
    });
    gsap.to(".co-clinic-reviews-drops-large img", {
      scrollTrigger: {
        trigger: ".co-clinic-reviews-drops-large",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: -15,
      xPercent: 5,
      rotateZ: 5
    });
    // REVIEWS
    let coClinicReviewsTextAni = document.querySelectorAll(
      ".co-clinic-reviews--ani"
    );
    gsap.set(coClinicReviewsTextAni, { opacity: 0 });
    gsap.to(coClinicReviewsTextAni, {
      scrollTrigger: {
        trigger: ".co-clinic-reviews",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 0.75,
      opacity: 1,
      // ease: "power2.inOut",
      stagger: 0.05,
    });
    
    gsap.to(".co-clinic-reviews-yelp>div", {
      scrollTrigger: {
        trigger: ".co-clinic-reviews-yelp",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      yPercent: -10,
      rotateZ: -2
    });

  });
});